export const DEFAULT_MANGO_LOGO_URL = "/new-mangomap-assets/svg/mangoicon.svg";
export const DEFAULT_WHITELABEL_LOADING_LOGO_URL =
	"https://placehold.co/60?text=Logo";

export interface WhitelabelBrandingConfig {
	removeBranding?: boolean | null;
	logoUrl?: string | null;
}

export const isWhitelabelEnabled = (
	brandingConfig?: WhitelabelBrandingConfig | null,
) => Boolean(brandingConfig?.removeBranding);

export const resolvePortalLogoUrl = (
	brandingConfig?: WhitelabelBrandingConfig | null,
): string | null => {
	const customLogoUrl = brandingConfig?.logoUrl?.trim();

	if (customLogoUrl) return customLogoUrl;
	if (isWhitelabelEnabled(brandingConfig)) return null;
	return DEFAULT_MANGO_LOGO_URL;
};

export const resolveLoadingLogoUrl = (
	brandingConfig?: WhitelabelBrandingConfig | null,
) => {
	const customLogoUrl = brandingConfig?.logoUrl?.trim();

	if (isWhitelabelEnabled(brandingConfig))
		return customLogoUrl ?? DEFAULT_WHITELABEL_LOADING_LOGO_URL;
	return DEFAULT_MANGO_LOGO_URL;
};
